import React, { useCallback } from 'react';
import { Loader } from 'js/components/common/Loader';
import { Button } from 'js/components/common/Button';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as actions from '../../store/actions';
import { useDynamicReducerDispatch } from '../../store';

import style from './Preloader.scss';

export const Preloader: React.FC = () => {
    const translate = useComponentTranslations();
    const dispatch = useDynamicReducerDispatch();

    const handleCancel = useCallback(() => {
        window.externalAuth?.cancel();

        dispatch(actions.setIsWaitingForBankIdConfirmation(false));
    }, [dispatch]);

    return (
        <div className={style.preloaderContainer}>
            <div>{translate('playtech.mobile.system.bankIDAuth.preloader.description')}</div>
            <Loader className={style.loader}/>
            <Button type="button" color="negative" className={style.cancelButton} onClick={handleCancel}>
                {translate('playtech.mobile.system.bankIDAuth.cancel')}
            </Button>
        </div>
    );
};
